import React from 'react';
import { motion } from 'framer-motion';
import { BadgeCheck, Plane, TrendingUp, Users, Star, Award } from 'lucide-react';
const stats = [{
  icon: Award,
  label: '+3 años',
  sub: 'de experiencia UGC'
}, {
  icon: TrendingUp,
  label: '+$20K USD',
  sub: 'facturados este 2026'
}, {
  icon: Star,
  label: '+500',
  sub: 'marcas confiaron'
}, {
  icon: Users,
  label: '+3.597',
  sub: 'alumnas activas'
}];
export function MentorSection() {
  return <section className="px-6 py-10 flex flex-col items-center text-center max-w-7xl mx-auto pt-[20px] pb-[20px]" data-id="element-228">
      <div className="w-full max-w-6xl relative rounded-[3rem] p-[2px] bg-gradient-to-b from-[#D98BAF]/80 via-brand-navy to-brand-navy shadow-[0_25px_60px_-15px_rgba(217,139,175,0.3)] mb-8" data-id="element-229">
        <div className="bg-brand-navy rounded-[2.9rem] px-6 py-10 md:px-12 md:py-12 relative overflow-hidden flex flex-col items-center" data-id="element-230">
          {/* Ambient glow */}
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[600px] bg-[#D98BAF]/15 blur-[140px] rounded-full pointer-events-none" data-id="element-231" />

          <div className="inline-flex items-center gap-2 bg-[#D98BAF]/15 border border-[#D98BAF]/40 text-[#D98BAF] font-bold text-[11px] md:text-sm uppercase tracking-[0.2em] px-6 py-2.5 rounded-full mb-8 backdrop-blur-sm relative z-10" data-id="element-232">
            <BadgeCheck size={16} strokeWidth={2.5} data-id="element-233" />
            Tu Mentora
          </div>

          <h2 className="font-serif font-bold text-3xl md:text-5xl lg:text-6xl text-white mb-16 leading-tight max-w-4xl relative z-10" data-id="element-234">
            ¿Quién soy y por qué soy la persona indicada para{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#D98BAF] to-[#fce7f1]" data-id="element-235">
              guiarte
            </span>
            ?
          </h2>

          <div className="w-full grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center relative z-10 text-left" data-id="element-236">
            {/* Image Column */}
            <div className="lg:col-span-5 flex flex-col items-center" data-id="element-237">
              <div className="relative w-64 h-64 md:w-80 md:h-80 mb-8" data-id="element-238">
                <div className="absolute -inset-4 bg-gradient-to-tr from-[#D98BAF] via-brand-pinkDark to-brand-lavender rounded-full blur-xl opacity-40 animate-pulse" data-id="element-239"></div>
                <div className="relative w-full h-full rounded-full overflow-hidden border-4 border-[#D98BAF]/50 shadow-[0_0_40px_rgba(217,139,175,0.4)]" data-id="element-240">
                  <img src="https://cdn.magicpatterns.com/uploads/i85boBmhYGDomz8PZSyPbd/pasted-image.png" alt="Brenda Hormaechea" className="w-full h-full object-cover" data-id="element-241" />
                </div>
                {/* Verified Badge Floating */}
                <div className="absolute bottom-4 right-4 bg-[#1d9bf0] text-white font-black text-xs md:text-sm px-4 py-2 rounded-full shadow-lg flex items-center gap-1.5 border-2 border-brand-navy" data-id="element-242">
                  <BadgeCheck size={16} strokeWidth={2.5} data-id="element-243" />
                  Verificada
                </div>
              </div>

              <h3 className="font-serif text-3xl md:text-4xl font-bold text-white mb-2 text-center" data-id="element-244">
                Brenda Hormaechea
              </h3>
              <div className="flex flex-wrap justify-center gap-2 mb-6" data-id="element-245">
                <span className="bg-white/10 text-white/90 text-xs font-bold uppercase tracking-widest px-3 py-1 rounded-full border border-white/20" data-id="element-246">
                  Creadora UGC
                </span>
                <span className="bg-[#D98BAF]/20 text-[#D98BAF] text-xs font-bold uppercase tracking-widest px-3 py-1 rounded-full border border-[#D98BAF]/30 flex items-center gap-1" data-id="element-247">
                  <Plane size={12} data-id="element-248" /> Viajera Frecuente
                </span>
              </div>
              <p className="text-white/60 font-medium text-center text-sm md:text-base max-w-xs" data-id="element-249">
                Más de <strong className="text-white" data-id="element-250">30.900 seguidores</strong>{' '}
                en Instagram construyendo una comunidad real.
              </p>
            </div>

            {/* Content Column */}
            <div className="lg:col-span-7 flex flex-col" data-id="element-251">
              <p className="font-serif text-white/90 text-xl md:text-2xl leading-relaxed mb-10" data-id="element-252">
                Te voy a enseñar el método exacto que me permitió dejar la
                oficina, viajar por el mundo y lograr tener{' '}
                <strong className="text-[#D98BAF] font-bold drop-shadow-[0_0_10px_rgba(217,139,175,0.4)]" data-id="element-253">
                  un portfolio lleno de trabajos UGC rentables.
                </strong>{' '}
                Sin secretos, con total transparencia.
              </p>

              {/* Stats Grid */}
              <div className="grid grid-cols-2 gap-4 md:gap-6 w-full" data-id="element-254">
                {stats.map((stat, i) => {
                const Icon = stat.icon;
                return <motion.div key={i} initial={{
                  opacity: 0,
                  y: 15
                }} whileInView={{
                  opacity: 1,
                  y: 0
                }} viewport={{
                  once: true
                }} transition={{
                  duration: 0.4,
                  delay: i * 0.1
                }} className="bg-white/[0.03] border border-white/10 rounded-3xl p-5 md:p-6 flex flex-col items-start hover:bg-white/[0.06] hover:border-[#D98BAF]/40 transition-all group" data-id="element-255">
                      <div className="w-10 h-10 rounded-xl bg-[#D98BAF]/10 flex items-center justify-center mb-4 group-hover:bg-[#D98BAF]/20 transition-colors" data-id="element-256">
                        <Icon size={20} className="text-[#D98BAF]" strokeWidth={2.5} data-id="element-257" />
                      </div>
                      <span className="font-serif text-white text-2xl md:text-3xl font-black leading-none mb-1 drop-shadow-md" data-id="element-258">
                        {stat.label}
                      </span>
                      <span className="text-white/60 text-sm md:text-base font-medium" data-id="element-259">
                        {stat.sub}
                      </span>
                    </motion.div>;
              })}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}